import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/context/AuthContext";

export default function JoinCampaign() {
  const { publicCode } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: "" });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/join/${encodeURIComponent(publicCode || "")}`);
        if (!cancelled) {
          setState({ loading: false, data: res.data, error: "" });
          if (res.data?.campaign_id) {
            sessionStorage.setItem("gdi_campaign_id", res.data.campaign_id);
          }
        }
      } catch (err) {
        if (!cancelled) {
          setState({
            loading: false,
            data: null,
            error: err?.response?.data?.detail || "This link is unavailable.",
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [publicCode]);

  if (state.loading) {
    return <p className="p-8" data-testid="join-loading">Loading campaign…</p>;
  }

  const data = state.data;
  if (!data?.ok) {
    return (
      <div className="max-w-lg mx-auto p-8 space-y-4" data-testid="join-unavailable">
        <h1 className="text-2xl font-semibold">GDI Academy</h1>
        <p>{data?.message || state.error || "This campaign link is not available."}</p>
        {data?.organisation_name ? <p className="text-sm text-muted-foreground">{data.organisation_name}</p> : null}
        <Link to="/" className="text-primary underline">Go to GDI Academy home</Link>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto p-8 space-y-6" data-testid="join-landing">
      <p className="text-sm uppercase tracking-wide text-muted-foreground">GDI Academy</p>
      <h1 className="text-3xl font-semibold">{data.landing_title}</h1>
      {data.organisation_name ? (
        <p className="text-lg">{data.organisation_name} · {data.campaign_name}</p>
      ) : null}
      <p>{data.landing_message}</p>
      <p className="text-sm text-muted-foreground">
        Free theory access only. Premium instructor training unlocks after booking confirmation and assignment.
      </p>
      <div className="flex gap-3 flex-wrap">
        <Link to="/register" className="px-4 py-2 rounded bg-primary text-primary-foreground" data-testid="join-register">
          Create free account
        </Link>
        <Link to="/login" className="px-4 py-2 rounded border" data-testid="join-login">
          Log in
        </Link>
      </div>
    </div>
  );
}
